const chunkMapping = {
	"55": [
		55
	],
	"313": [
		313
	],
	"333": [
		333
	],
	"339": [
		339
	],
	"343": [
		343
	],
	"347": [
		347
	],
	"445": [
		445
	],
	"571": [
		571
	],
	"615": [
		615
	],
	"641": [
		641
	],
	"679": [
		679
	],
	"710": [
		710
	],
	"725": [
		725
	],
	"735": [
		735
	],
	"739": [
		739
	],
	"782": [
		782
	],
	"892": [
		892
	],
	"915": [
		915
	],
	"984": [
		984
	]
};
const idToExternalAndNameMapping = {
	"55": [
		"default",
		"./workspace",
		721
	],
	"313": [
		"default",
		"./modules",
		687
	],
	"333": [
		"default",
		"./about",
		387
	],
	"339": [
		"default",
		"./audit",
		387
	],
	"343": [
		"default",
		"./terms",
		387
	],
	"347": [
		"default",
		"./docs",
		387
	],
	"445": [
		"default",
		"./authSuccess",
		387
	],
	"571": [
		"default",
		"./authorize",
		387
	],
	"615": [
		"default",
		"./service",
		387
	],
	"641": [
		"default",
		"./profile",
		387
	],
	"679": [
		"default",
		"./telemetryConsent",
		387
	],
	"710": [
		"default",
		"./mySubscriptions",
		459
	],
	"725": [
		"default",
		"./downloads",
		387
	],
	"735": [
		"default",
		"./registry",
		387
	],
	"739": [
		"default",
		"./accountSelection",
		387
	],
	"782": [
		"default",
		"./workspaces",
		721
	],
	"892": [
		"default",
		"./cloudlinks",
		387
	],
	"915": [
		"default",
		"./home",
		387
	],
	"984": [
		"default",
		"./tokens",
		387
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}